import { Button as ShrikeButton } from '@arcadiapower/shrike';
import { omit } from 'lodash';
import { ComponentProps, MouseEvent, PropsWithChildren } from 'react';
import { SpaceProps } from 'styled-system';
import { LegacyTrackingEvent, trackEvent } from '~/utils/tracking';
import { StyledButton } from './button.style';

type ShrikeButtonProps = ComponentProps<typeof ShrikeButton>;
interface Props extends Omit<ShrikeButtonProps, 'margin'>, SpaceProps {
  fullWidth?: boolean;
  testId?: string;
  track?: LegacyTrackingEvent;
}

export type ButtonProps = PropsWithChildren<Props>;

export const Button = (props: ButtonProps) => {
  const { children, fullWidth = true, onClick, testId, track } = props;

  return (
    // @ts-expect-error collision w/ shrike margin and styled system margin (we're using the latter)
    <StyledButton
      fullWidth={fullWidth}
      {...omit(props, ['testId', 'track'])}
      data-testid={testId}
      onClick={(e: MouseEvent<HTMLButtonElement>) => {
        if (track) trackEvent(track);
        if (onClick) onClick(e);
      }}
    >
      {children}
    </StyledButton>
  );
};
